// src/app/RouteMeta.jsx
// 화면 이동 시 문서 제목·설명을 라우트에 맞게 바꾼다 (JS를 실행하는 검색 로봇·브라우저 탭 제목용).
// 첫 진입 HTML의 제목·설명·canonical은 빌드 후 scripts/prerender-seo.js가 같은 seoRoutes.json으로 만든다.
// <Routes>보다 앞에 둬야 한다 — 페이지가 직접 제목을 정하는 경우(TermsPage) 그 effect가 이보다 나중에 실행돼 우선한다.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import seo from "./seo/seoRoutes.json";

function setDescription(content) {
    const el = document.querySelector('meta[name="description"]');
    if (el) el.setAttribute("content", content);
}

export function RouteMeta() {
    const { pathname } = useLocation();

    useEffect(() => {
        const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
        const page = seo.routes[path] || seo.default;
        document.title = page.title;
        setDescription(page.description);
    }, [pathname]);

    return null;
}
